import type { ReactNode } from 'react';

import { Card, CardContent } from '../../ui/card';
import { Group, Stack } from '@folio/components/ui/flex';
import { Title } from '@folio/components/ui/text';

type AuthLayoutProps = {
  title: ReactNode;
  logo: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export const AuthLayout = ({ children, title, logo, footer }: AuthLayoutProps) => {
  return (
    <>
      <Stack
        justify="center"
        gap={0}
        className="min-h-screen flex-1 py-12 sm:px-6 lg:px-8 bg-gray-50"
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <Group align="stretch" justify="center" gap={0} className="mx-auto w-auto">
            {logo}
          </Group>
          <Title
            order={2}
            size="2xl"
            className="mt-6 text-center leading-9 tracking-tight text-gray-700 font-bold"
          >
            {title}
          </Title>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <Card className="rounded-none border-r-0  sm:rounded-lg sm:border-r">
            <CardContent className="py-6">{children}</CardContent>
          </Card>

          <div className="mt-10 text-center text-sm text-gray-500">{footer}</div>
        </div>
      </Stack>
    </>
  );
};
